import { render, staticRenderFns } from "./XomeDisk.vue?vue&type=template&id=43747910&"
import script from "./XomeDisk.vue?vue&type=script&lang=js&"
export * from "./XomeDisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports